// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Reprocessos_CriarResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for POST /so/reprocessos/criar.
 *
 * Returns the inserted so_reprocesso_id as the dados primitive (legacy
 * wire shape: `dados: <id>`).
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Reprocessos_CriarResponseDados = number;

export type Reprocessos_CriarResponse = ApiResponse<Reprocessos_CriarResponseDados>;

registerResponseContract('Reprocessos_CriarResponse', {})
